<template>
  <modal
    name="task-modal"
    @opened="viewComments(oneTask)"
    @closed="clearComments"
    :resizable="true"
    :height="'auto'"
    :width="'90%'"
    :scrollable="true"
  >
  <!-- {{ oneTask }} -->
    <div class="container p-3">
      <div class="row justify-content-center" style="background-color:#f5f7f9;">
        <img :src="oneTask.imageUrl" alt style="max-height:300px;" />
      </div>

      <div class="row p-3">
        <div class="col-12">
          <h3>
            <span
              v-if="oneTask.status=='dodany'"
              class="text-right badge badge-info"
            >{{oneTask.status}}</span>
            <span v-else class="text-right badge badge-success">{{oneTask.status}}</span>
          </h3>
        </div>
        <div class="col-12">
          <h3>{{ oneTask.title }}</h3>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-9">
          <p class="text-muted h6">
            <svg
              width="1.5em"
              height="1.5em"
              viewBox="0 0 16 16"
              class="bi bi-person-plus-fill"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7.5-3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
              />
              <path
                fill-rule="evenodd"
                d="M13 7.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0v-2z"
              />
            </svg>
            {{oneTask.userName}}
          </p>
        </div>

        <div class="col-3 d-flex justify-content-end">
          <p
            class="text-right align-text-top badge badge-primary badge-pill"
          >{{oneTask.createdOn | formatDate}}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <h5>Rower</h5>
          <hr />
          <p>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-bicycle"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M3 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm10-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
              />
              <path
                fill-rule="evenodd"
                d="M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935 2.375 3.8a.5.5 0 1 1-.848.53L10.5 6.943l-2.076 3.322A.5.5 0 0 1 8 10.5H3a.5.5 0 0 1-.424-.765L5 5.857V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443L3.902 9.5h3.196L5.5 6.943zM8 9.057L9.598 6.5H6.402L8 9.057z"
              />
            </svg>
            {{oneTask.bike}}
          </p>
          <!-- <p>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-bicycle"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M3 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm10-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
              />
              <path
                fill-rule="evenodd"
                d="M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935 2.375 3.8a.5.5 0 1 1-.848.53L10.5 6.943l-2.076 3.322A.5.5 0 0 1 8 10.5H3a.5.5 0 0 1-.424-.765L5 5.857V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443L3.902 9.5h3.196L5.5 6.943zM8 9.057L9.598 6.5H6.402L8 9.057z"
              />
            </svg>
            {{oneTask.frame}}
          </p> -->
          <hr />
        </div>
        <div class="col-12 col-md-6">
          <h5>Klient</h5>
          <hr />
          <p>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-telephone"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M3.925 1.745a.636.636 0 0 0-.951-.059l-.97.97c-.453.453-.62 1.095-.421 1.658A16.47 16.47 0 0 0 5.49 10.51a16.471 16.471 0 0 0 6.196 3.907c.563.198 1.205.032 1.658-.421l.97-.97a.636.636 0 0 0-.06-.951l-2.162-1.682a.636.636 0 0 0-.544-.115l-2.052.513a1.636 1.636 0 0 1-1.554-.43L5.64 8.058a1.636 1.636 0 0 1-.43-1.554l.513-2.052a.636.636 0 0 0-.115-.544L3.925 1.745zM2.267.98a1.636 1.636 0 0 1 2.448.153l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.47 17.47 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969z"
              />
            </svg>
            <a :href="`tel:${oneTask.phone}`" style="text-decoration:none;">{{oneTask.phone}}</a>
            <br />
            <br />
            <a :href="`sms:${oneTask.phone}&body=Serwis Zico-Bike: `">
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-chat-left-text"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M14 1H2a1 1 0 0 0-1 1v11.586l2-2A2 2 0 0 1 4.414 11H14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                />
                <path
                  fill-rule="evenodd"
                  d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                />
              </svg> SMS
            </a>
          </p>
          <p>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-house"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            {{oneTask.address}}
          </p>
          <hr />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 d-flex justify-content-center border-bottom-primary">
          <p>Opis usterki:</p>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <p>{{oneTask.content}}</p>
        </div>
      </div>
      <hr>
      <div class="row justify-content-end mt-2">
        <div class="col-4">
<button class="btn btn-info" style="width:100%;" @click="addComment(oneTask)">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-chat-left-dots"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M14 1H2a1 1 0 0 0-1 1v11.586l2-2A2 2 0 0 1 4.414 11H14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
            <path
              d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            />
          </svg>
        </button>

        </div>
        <div class="col-4">

          <button
          v-if="!oneTask.endDate"
          class="btn btn-warning" style="width:100%;"
          @click="changeStatusTask(oneTask)"
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-flag"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M3.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"
            />
            <path
              fill-rule="evenodd"
              d="M3.762 2.558C4.735 1.909 5.348 1.5 6.5 1.5c.653 0 1.139.325 1.495.562l.032.022c.391.26.646.416.973.416.168 0 .356-.042.587-.126a8.89 8.89 0 0 0 .593-.25c.058-.027.117-.053.18-.08.57-.255 1.278-.544 2.14-.544a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5c-.638 0-1.18.21-1.734.457l-.159.07c-.22.1-.453.205-.678.287A2.719 2.719 0 0 1 9 9.5c-.653 0-1.139-.325-1.495-.562l-.032-.022c-.391-.26-.646-.416-.973-.416-.833 0-1.218.246-2.223.916a.5.5 0 1 1-.515-.858C4.735 7.909 5.348 7.5 6.5 7.5c.653 0 1.139.325 1.495.562l.032.022c.391.26.646.416.973.416.168 0 .356-.042.587-.126.187-.068.376-.153.593-.25.058-.027.117-.053.18-.08.456-.204 1-.43 1.64-.512V2.543c-.433.074-.83.234-1.234.414l-.159.07c-.22.1-.453.205-.678.287A2.719 2.719 0 0 1 9 3.5c-.653 0-1.139-.325-1.495-.562l-.032-.022c-.391-.26-.646-.416-.973-.416-.833 0-1.218.246-2.223.916a.5.5 0 0 1-.554-.832l.04-.026z"
            />
          </svg>
        </button>
        </div>
        <div class="col-4">
 <button v-if="!oneTask.endDate" class="btn btn-success" style="width:100%;" @click="printTask(oneTask)">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-printer"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 2H5a1 1 0 0 0-1 1v2H3V3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h-1V3a1 1 0 0 0-1-1zm3 4H2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v1H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
            />
            <path
              fill-rule="evenodd"
              d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM5 8a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H5z"
            />
            <path d="M3 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
          </svg>
        </button>

        </div>
       
      </div>
      <hr />
      <div>

        <form class="form-group" @submit.prevent>
        <textarea class="form-control" v-model.trim="oneTask.clientComment" placeholder="Uwagi dla klienta"></textarea>
        <div class="row">
           <button @click="addClientComment(oneTask)" :disabled="oneTask.clientComment == ''" class="btn btn-success m-3">Dodaj uwagi</button>
        </div>
       
      </form>

      </div>
      <div class="row m-2 justify-content-center">
        <span class="text-muted">Komentarze</span>
      </div>

      <div v-if="taskComments.length != 0" class="list-group overflow-auto comments-view">
        <div
          v-for="comment in taskComments"
          :key="comment.id"
          class="list-group-item list-group-item-action flex-column align-items-start"
        >
          <div class="row">
            <div class="col">{{ comment.userName }}</div>
            <div class="col d-flex justify-content-end">
              <span class="badge badge-light badge-pill">{{ comment.createdOn | formatDate }}</span>
            </div>
          </div>
          <div class="row m-1 border border-light">
            <p style="font-size:13px">{{ comment.content }}</p>
          </div>
        </div>
      </div>
      <div v-else-if="loader" style="height:50px;">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;"
          width="50px"
          height="50px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <g transform="rotate(0 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.9166666666666666s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(30 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.8333333333333334s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(60 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.75s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(90 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.6666666666666666s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(120 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.5833333333333334s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(150 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.5s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(180 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.4166666666666667s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(210 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.3333333333333333s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(240 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.25s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(270 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.16666666666666666s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(300 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="-0.08333333333333333s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <g transform="rotate(330 50 50)">
            <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#93dbe9">
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              />
            </rect>
          </g>
          <!-- [ldio] generated by https://loading.io/ -->
        </svg>
      </div>
      <div v-else>Brak komentarzy</div>

      <print-modal :oneTask="oneTask"></print-modal>

      
    </div>
  </modal>
</template>
<script>
import { tasksCollection, commentsCollection } from "@/firebase";
import * as firebase from "../firebase";
import moment from "moment";
import PrintModal from "@/components/PrintModal.vue";

export default {
  data() {
    return {
      // fullPost: {},
      taskComments: [],
      testArr: [],
      thisIsFirstTime: true,
      output: null,
      loader: true,
      status: "w trakcie",
      // clientComment:this.oneTask.clientComment
    };
  },
  props: ["oneTask"],

  components: {
    "print-modal": PrintModal,
  },

  methods: {
    addComment(task) {
      this.$modal.show("comment-modal");
      this.oneTask = task;
    },
    printTask(task) {
      this.$modal.show("print-modal");
      this.oneTask = task;
    },
    print() {
      this.$htmlToPaper("printMe");
    },
    changeStatusTask(task) {
      if (task.status == "dodany") {
        this.$store.dispatch("updateTaskStatus", {
          task,
          statusToChange: "w trakcie",
        });
        alert("status zmieniony");
        task.status = "w trakcie";
      } else {
        if (confirm("Czy napewno chcesz zamknąć zlecenie?")) {
          this.$store.dispatch("updateTaskStatus", {
            task,
            statusToChange: "zrealizowany",
            endDate: true,
          });
          this.$modal.hide("task-modal");
        }
      }
    },
    addClientComment(task){
      console.log(task)
      console.log(this.oneTask.clientComment)
      this.$store.dispatch("addClientComment", {
        task,
        clientComment: this.oneTask.clientComment
      })
    },
    clearComments() {
      this.$emit("clear-comments");
    },

    async viewComments(oneTask) {
      this.loader = true;
      const docs = await commentsCollection
        .orderBy("createdOn", "desc")
        .where("taskId", "==", oneTask.id)
        .get();
      docs.forEach((doc) => {
        this.taskComments.push(doc.data());
      });
      this.loader = false;
    },
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      moment.locale("pl");
      return moment(date).fromNow();
    },
  },
};
</script>
<style scoped>
.comments-view {
  max-height: 200px;
  /* border: 1px solid red; */
}
.comment {
  border: 1px solid green;
}

a {
  color: #000;
}
</style>